
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 29 32","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"29","height":"32","data-name":"Vector Smart Object","xlink:href":"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAgCAQAAABEfrv3AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfkBwcLDzddhkG8AAADRUlEQVQ4y32VX2hUVxDGf7tejTGpudvsnyipRpPYoFZTUGvQFOkWjFRMQaR9sT6pJfShFAptFRWRQqGtLVJQUFRWCKYvbbXqk3/qQ7SpEkm1kGx0tWhMuphLE9gkRj8f9mRz7901My/3fDPfnTlz5pxB5DSgJp1Sr8aUL0/Vq1NqUmDSf5JYq3bd026tUUzlWqzNOiJHraqUrXLFtEa7dU/tqvVT31RaB1TkygGhqH5Vp0JCjTqhE0rolka0LmsNCCBMJ99wiHyZRoIw66mi2SANrGU5aUzUo2r1xZvUYvXoIw/SqqMTUau4TS2PeJk0c5AanrOCtQCU8RVv0B0EdtI2BRHOMM4GYA711FPPAlLszCacVNyVzkzt0Beq8qS4X8c867iSIqB5/EMZ47kYZ6mgl3dYRl8Oe4s25gMLmWeKd5YlFqv400WMsJ4Qw5yhmcM59AZRYvSzLVfnp2wIUscd176GGWMFYRbR70LHSVIH7DW7rSdBKEgtSZdTho/5nQE6+M1Tqh5qACjBxsbmIXUW1fzscUrQRglPfFXuYRFg8ZAygzwJ8ippn1uEKGEflsYGxrEJECBAA/1BQgzmHIrYQx9J/qCPLra6qA4hz68cQhYhHLOcwXlK2EI7zyhmE99Txy5jGzTU9/nU+EYsihg15j0U0ciYKddp2rnBVS6YGk8H4Bo/mHI1IMkWQraGtMTX+tt13Xw16bLHYksWMAzARjq57StOgh+Zz31ghFcAWMwOAIIQBGYCEOdcXuOPcJG42VvGIA4ODsOARhURQl2eSzCh+/STENqsix48rFGLAWL8Byykm3zppgGAKI8BeI8IAK8xaJGihr8pZxb/FqA+MHelhpShzgWggiGLLpbyC2V5rTdxntnGW8pxAFpyB1lh8RdbgNkMFaQ6zAamsZpPgKiJCXFOokplVKxVulPwUbMlobd1Vwh9q5RSSum+nqkSoQ59oHXqnIJ6SN950A/VkX3CW3RJjVNQS+VomQe9opYstVRptZiU/DpH/+tLXRBCj3ITaESlE4PjM/XpcUHq68rI0UrzmNuyVa5b+nxy5li6KeVNHITelXRMtku/1k1Z7nFVrQHFClC36rlvXGZUnbW9ACo+eQhT44qMAAAAAElFTkSuQmCC"}})])
          )
        }
      }
    